import { attributes, Model, type } from "@type-r/models";

export const SourceAsset = attributes({
    id: Number,
    appCode: String,
    platformCode: String,
    sourceTransactionId: Number
});

export type State = InstanceType<typeof State>;
export const State = attributes({
    id: Number,
    name: String,
    productStates: Object,
});

export const AssetType = attributes({
    id: Number,
    name: String
});

export abstract class AssetData extends Model {

    static attributes = {
        assetId: Number,
        uid: type(String).value('00000000-0000-0000-0000-000000000000'),
        productCode: String,
        platformCode: String,
        dataHolderId: type(Number).null,
        sourceAsset: type(SourceAsset).value({}),
        number: String,
        state: type(State).value({ id: 1, name: 'Draft' }),
        importJobId: Number,
        documentId: type(String).value('00000000-0000-0000-0000-000000000000'),
        originalFileName: String,
        originalFileUrl: String,
        createdBy: String,
        createdOn: Date,
        updatedBy: String,
        updatedOn: Date,

        errors: type(Object).dontSave,
        warnings: type(Object).dontSave,
    };

    abstract onLoaded();

    resolveIssues() {
        const dynamic: any = this;
        var errors = dynamic.errors || {};
        var warnings = dynamic.warnings || {};
        var result = {};
        Object.keys(warnings).map(key => (result[ key ] = warnings[ key ]));
        Object.keys(errors).map(key => (result[ key ] = errors[ key ]));
        return result;
    }
}
